import script from "./PermissionsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PermissionsPage.vue?vue&type=script&setup=true&lang=ts"

import "./PermissionsPage.vue?vue&type=style&index=0&id=8fe4f684&lang=scss"

const __exports__ = script;

export default __exports__